<template>
  <v-list-item>
    <v-list-item-icon @click="$emit('select', dependent)">
      <v-avatar color="indigo" size="40">
        <span class="white--text subtitle-1">{{ letters }}</span>
      </v-avatar>
    </v-list-item-icon>

    <v-list-item-content @click="$emit('select', dependent)">
      <v-list-item-title>{{ dependent.name }}</v-list-item-title>
    </v-list-item-content>

    <v-list-item-icon v-if="showButtons">
      <v-icon color="grey" @click="$emit('share', dependent)">
        mdi-share-variant-outline
      </v-icon>
      <v-icon color="grey" @click="$emit('edit', dependent)">
        mdi-pencil
      </v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>

export default {
  name: 'DependentCard',
  props: {
    dependent: {
      type: Object,
      required: true
    },
    showButtons: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    letters() {
      const names = this.dependent.name.split(' ')
      const first = names[0].substring(0, 1)
      const last = names[names.length - 1].substring(0, 1)
      return `${first}${last}`
    }
  }
}
</script>
